import { combineReducers } from 'redux';

import headerReducer from './Header';
import ProductionPlanningReducer from './ProductionPlanning';
import UserReducer from './UserReducer';
import ProductionPlanTabReducer from './ProductionPlanning/ProductionPlan';
import ConfigReducer from './ConfigManagement';
import RetailProductionPlanningReducer from './RetailProductionPlanning';

const appReducer = combineReducers({
  header: headerReducer,
  authReducer: UserReducer,
  retailProductionPlanningReducer: RetailProductionPlanningReducer,
  productionPlanningReducer: ProductionPlanningReducer,
  productionPlanTabReducer: ProductionPlanTabReducer,
  configReducer: ConfigReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

// export default rootReducer;
export default rootReducer;
